import { Box, Typography, Divider } from "@mui/material"

export interface IItemizedListProps {
    project: number;
    serviceFee: number;
}

const ItemizedList = ({ project, serviceFee}:IItemizedListProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const formatPrice = (price: number) => ('$' + price.toFixed(2));
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Box 
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            width={'100%'}
            alignItems={'center'}
            paddingX={10}
            gap={1}
        >
            <Box 
                display={'flex'} 
                flexDirection={'row'}
                width={'100%'}
            >
                <Box
                    flex={1}
                    justifyContent={'flex-start'}
                >
                    <Typography>Project</Typography>
                </Box>
                <Box>
                    <Typography>{formatPrice(project)}</Typography>
                </Box>
            </Box>
            <Divider sx={{width: '100%'}} />
            <Box 
                display={'flex'} 
                flexDirection={'row'}
                width={'100%'}
            >
                <Box
                    flex={1}
                    justifyContent={'flex-start'}
                >
                    <Typography>Service fee</Typography>
                </Box>
                <Box>                                    
                    <Typography>{formatPrice(serviceFee)}</Typography>
                </Box>
            </Box>
            <Divider sx={{width: '100%'}} />
            <Box 
                display={'flex'} 
                flexDirection={'row'}
                width={'100%'}
            >
                <Box
                    flex={1}
                    justifyContent={'flex-start'}
                >                                    
                    <Typography>Total</Typography>
                </Box>
                <Box>
                    <Typography>{formatPrice(project + serviceFee)}</Typography>
                </Box>
            </Box>
            <Divider sx={{width: '100%'}} />
        </Box>
    )
}

export default ItemizedList